export default __webpack_public_path__ + "static/media/ana_sabino.995127d2.png";